<template>
	<modal ref="modal" size="modal-xl">
		<template #title>Member Information</template>
		<template #body>
			<div class="row">
				<div v-if="member!=null" class="col-md-12">
					<div class="form-group mb-4">
						<h4 class="text-center fw-bold">
							<span v-if="member.is_verified==1" class="text-success">VERIFICATION COMPLETE</span>
							<span v-else class="text-danger">NOT YET VERIFIED</span>
						</h4>
					</div>
				</div>
				<div class="col-md-7">
					<div class="form-floating mb-4">
						<div class="form-control">{{member!=null ? member.fname : ''}}</div>
						<label class="form-label">First Name</label>
					</div>
					<div class="form-floating mb-4">
						<div class="form-control">{{member!=null ? member.mname : ''}}</div>
						<label class="form-label">Middle Name</label>
					</div>
					<div class="form-floating mb-4">
						<div class="form-control">{{member!=null ? member.lname : ''}}</div>
						<label class="form-label">Last Name</label>
					</div>
					<div class="form-floating mb-4">
						<div class="form-control">{{member!=null ? member.bday : ''}}</div>
						<label class="form-label">Birth Date</label>
					</div>
					<div class="form-floating mb-4">
						<div class="form-control">{{member!=null ? member.age : ''}}</div>
						<label class="form-label">Age</label>
					</div>
					<div class="form-floating mb-4">
						<div class="form-control">{{member!=null ? member.mobile : ''}}</div>
						<label class="form-label">Mobile</label>
					</div>
					<div class="form-floating mb-4">
						<div class="form-control">{{member!=null ? (member.id_type??'None'):'None'}}</div>
						<label class="form-label">ID Type</label>
					</div>
				</div>
				<div class="col-md-5">
					<div class="mb-4">
						<label class="fw-bold">Document Information <span v-if="member!==null && member.is_docu_reupload==1" class="badge bg-warning">Re-uploaded</span></label>
						<div class="p-3 border" style="height:300px;">
							<a :href="docu_link" target="_blank"><img :src="docu_link" style="width: 100%;height: 100%;" title="Document" /></a>
						</div>
					</div>
					<div v-if="member!=null">
						<div v-if="member.is_docu_approved==0 && member.id_type_uploaded!=null" class="mb-3">
							<button @click="updateDocument('approved')" type="button" class="btn btn-alt-success btn-sm me-2"><i class="fa fa-check me-1"></i>Approved ID</button>
							<button @click="updateDocument('rejected')" type="button" class="btn btn-alt-danger btn-sm"><i class="fa fa-times me-1"></i>Reject ID</button>
						</div>
					</div>
					<div >
						<label>Rejection Notes</label>
						<textarea v-model="form.docu_remarks" class="form-control" style="height:150px;"></textarea>
						<div v-if="form.errors.docu_remarks && (form.docu_remarks=='' || form.docu_remarks==null)" class="show-error">
							<i class="fa fa-exclamation-circle"></i>
							{{ form.errors.docu_remarks }}
						</div>
					</div>
				</div>
			</div>
		</template>
		<template #footer>
			<span v-if="member!=null">
				<button v-if="member.is_docu_approved==1 && member.is_verified==0"
					@click="verified"
					type="button"
					class="btn btn-alt-success"
					:disabled="form.processing"
				>
					<i class="fa fa-check-circle me-1"></i>
					<span v-if="!form.processing">Verified Insurance</span>
					<span v-else>
						<div class="spinner-border spinner-border-sm text-dark" role="status" >
							<span class="sr-only mr-1">Please wait...</span>
						</div>
						<span class="mx-2">Please wait...</span>
					</span>
				</button>
			</span>
			<button
				@click="toggleModal"
				type="button"
				class="btn btn-alt-secondary"
				:disabled="form.processing"
			>
				<i class="fa fa-times me-1"></i>
				Close
			</button>
		</template>
	</modal>
</template>

<script>
	import { watch, ref } from 'vue';
	import { useForm } from '@inertiajs/inertia-vue3';

	export default {
		props:{
			apiResponse : Object
		},
		setup(props){

			const modal 	= ref(null);
			const action 	= ref('verify');

			const docu_link = ref("");

			const form = useForm({
				is_docu_approved : 0,
				is_docu_rejected : 0,
				is_docu_reupload : 0,
				docu_remarks 	 : null
			});

			const toggleModal = () => {
									modal.value.toggleModal();
								};

			const member = ref(null);

			const setMember = (data)=>{
								
								member.value = data;
							
								viewDocument(member.value.id_type_uploaded);	
								// console.log(data);
							}

			const viewDocument = (docu)=>{
				// axios.get("group-insurance/view-document/"+docu,{},{
				// 	onSuccess:(res)=>{
				// 		console.log(res);
				// 	}
				// })

				axios.get('/api/admin/group-insurance/view-document/'+docu)
				   	.then(res => {
				      docu_link.value = res.data;
				   	})
			}

			const verified = ()=>{
				action.value = 'verify';
				form.put("group-insurance/"+member.value.counter,{},{
					only:['members','api_response'],
				})
			}

			const updateDocument = (_action)=>{

				if(_action=='rejected')
				{
					action.value = 'reject';
					form.is_docu_approved = 0;
				    form.is_docu_rejected = 1;
				    form.is_docu_reupload = 0;
				} else
				{
					action.value = 'approve';
					form.is_docu_approved = 1;
				    form.is_docu_rejected = 0;
				    form.is_docu_reupload = 0;
				}

				form.put("group-insurance/document/"+member.value.counter,
					{},{
					only:['members','api_response'],	
				})
			}

			watch(()=>props.apiResponse, (value) => {
				if(value.result=="success")
				{
					if(action.value=='approve')
					{
						member.value.is_docu_approved = form.is_docu_approved
						member.value.is_docu_rejected = form.is_docu_rejected
						member.value.is_docu_reupload = form.is_docu_reupload
					}

					if(action.value=='reject')
					{
						member.value.docu_remarks = form.docu_remarks;
					}

					if(action.value=='verify')
					{
						member.value.is_verified = 1;
					}

				}
			})

			return{
				action,
				docu_link,
				modal,
				form,
				toggleModal,
				member,
				setMember,
				viewDocument,
				updateDocument,
				verified
			}
		}
	}

</script>